import userGroupsServices from '../services/userGroupsServices';

import { UserGroupsActions } from '../types/UserGroupsActions';
import { UserGroupsBody } from '../types/UserGroupsBody';

const userGroupsList = () => (dispatch: any) => {
    const success = (data: UserGroupsBody[]): UserGroupsActions =>
        ({ type: 'USER_GROUPS_LIST_SUCCESS', data });
    userGroupsServices.list().then((res: any) => dispatch(success(res)));
}

const getUserGroupsCount = () => (dispatch: any) => {
    const success = (data: number): UserGroupsActions =>
        ({ type: 'USER_GROUP_COUNT_SUCCESS', data });

    userGroupsServices.count()
        .then((res: any) => dispatch(success(res)));
}

const assignRole = (formData: any) => {
    return userGroupsServices.assignRole(formData);
}

const removeRole = (groupId: string, roleId: string, miniLibraryId: string) => {
    return userGroupsServices.removeRole(groupId, roleId, miniLibraryId);
}

export {
    userGroupsList,
    getUserGroupsCount,
    assignRole,
    removeRole
};